// Keep the theme's hover/close behavior while also allowing click and keyboard activation.
if (!window.acSupportMenuBound) {
  window.acSupportMenuBound = true;
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-ac-support-trigger]');
    if (!summary) return;
    const details = summary.parentElement;
    if (details.trigger !== 'hover') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    details.open = !details.open;
  }, true);
}
